var cov_i2oxd4znz = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/context.tsx",
      hash = "af867a85a68ee8cc68b7f67cfa1c46438cc115db",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "1": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 8,
          column: 40
        }
      },
      "2": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "3": {
        start: {
          line: 12,
          column: 45
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "4": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 18,
          column: 21
        }
      },
      "5": {
        start: {
          line: 15,
          column: 17
        },
        end: {
          line: 15,
          column: 102
        }
      },
      "6": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 18
          },
          end: {
            line: 10,
            column: 19
          }
        },
        loc: {
          start: {
            line: 12,
            column: 45
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 45
          },
          end: {
            line: 12,
            column: 46
          }
        },
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 18,
            column: 21
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 5
          },
          end: {
            line: 14,
            column: 6
          }
        },
        loc: {
          start: {
            line: 14,
            column: 14
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 14
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 42
          },
          end: {
            line: 15,
            column: 101
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 42
          },
          end: {
            line: 15,
            column: 47
          }
        }, {
          start: {
            line: 15,
            column: 51
          },
          end: {
            line: 15,
            column: 79
          }
        }, {
          start: {
            line: 15,
            column: 83
          },
          end: {
            line: 15,
            column: 101
          }
        }],
        line: 15
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_i2oxd4znz.s[0]++, createReactContext(undefined)); // eslint-disable-next-line

export var Provider = (cov_i2oxd4znz.s[1]++, context.Provider);
cov_i2oxd4znz.s[2]++;

var consumer = function consumer(Origin) {
  cov_i2oxd4znz.f[0]++;
  cov_i2oxd4znz.s[3]++;
  return function (props) {
    cov_i2oxd4znz.f[1]++;
    cov_i2oxd4znz.s[4]++;
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13,
          columnNumber: 3
        }
      }, function (value) {
        cov_i2oxd4znz.f[2]++;
        var mp = (cov_i2oxd4znz.s[5]++, Object.assign({}, props, (cov_i2oxd4znz.b[0][0]++, value) && (cov_i2oxd4znz.b[0][1]++, props.absolute === undefined) && (cov_i2oxd4znz.b[0][2]++, {
          absolute: true
        })));
        cov_i2oxd4znz.s[6]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, mp, {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 16,
              columnNumber: 14
            }
          }))
        );
      })
    );
  };
};

export default consumer;